import React, { useState } from 'react';
import Modal from '../common/Modal';
import Button from '../common/Button';
import Textarea from '../common/Textarea';
import { useCart } from '../../context/CartContext';
import api from '../../services/api';
import toast from 'react-hot-toast';

const HoldSaleModal = ({ isOpen, onClose }) => {
  const { items, customer, notes, setNotes } = useCart();
  const [loading, setLoading] = useState(false);

  const handleHoldSale = async () => {
    setLoading(true);
    try {
      await api.post('/pos.php/hold', {
        items: items.map(item => ({
          product_id: item.id,
          quantity: item.quantity,
          price: item.selling_price
        })),
        customer_id: customer?.id,
        notes
      });
      toast.success('Sale held successfully');
      onClose();
    } catch (error) {
      toast.error('Failed to hold sale');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Hold Current Sale">
      <div className="hold-sale-modal">
        <p>Are you sure you want to hold this sale?</p>
        <p className="items-count">Items in cart: {items.length}</p>
        
        <Textarea
          label="Notes (Optional)"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Add notes for this held sale"
          rows={3}
        />

        <div className="modal-actions">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleHoldSale} loading={loading}>
            Hold Sale
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default HoldSaleModal;